<template>
  <el-popover v-model="visible" placement="bottom" trigger="hover">
    <div class="msg-content" id="mailMsgBox">
      <div>
        <div class="reply-msg" v-for="item in list" :key="item.id" @click="toMsgItem(item)">
          <div class="reply-msg-inner">
            <img class="mr-[10px]" :src="item.category !== 'system' ? item.avatar:require('@/assets/notice.svg')" :class="item.category !== 'system' && 'reply-msg-avatar'" />
            <div class="reply-msg-content">
              <div :class="'text-[#1D1D1D] text-[16px] font-semibold'" v-html="item.message"></div>
              <div class="text-[#646464] text-[14px] font-normal">标题：{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div v-if="loading" class="loading-box">加载中...</div>
        <div v-if="!loading && !list.length" class="no-data-box">暂无数据</div>
      </div>
      <div class="link-btn"><span @click="toMsg">查看全部</span></div>
    </div>
    <div slot="reference" class="mx-[20px] relative">
      <div v-if="unreadNotifyCount" class="count">{{ unreadNotifyCount > 99 ? "99+" : unreadNotifyCount }}</div>
      <svg-icon icon-class="bell" width="21px" height="26px" />
    </div>
  </el-popover>
</template>

<script>
import { getAllCount } from "@/api/user"; // get token from cookie
import { mapGetters } from 'vuex'
export default {
  name: "MsgBox",
  data() {
    return {
      visible:false,
      list: [],
       
      loading: false,
    };
  },
  computed:{ 
    ...mapGetters(['unreadNotifyCount'])
  },
  mounted() {
    this.getData();
    document.addEventListener('wheel',(e) => {
      this.visible = false
    })
    
    document.addEventListener('mousedown', (e)=>{
      if(!document.querySelector("#mailMsgBox")?.contains?.(e.target)){
        this.visible = false
      }
    })
  },
  methods: {
    toMsg() {
      // location.href = "/community/forum.php?mod=mail";
      location.href = "/#/forum/mail";
    },
    toMsgItem(item){
      if(item?.category === 'system'){
        localStorage.setItem('msg-tab','sys')
      } else {
        localStorage.setItem('msg-tab','');
        location.href = item.redirect_url;
        setTimeout(() => {
          this.$store.state.app.render = !this.$store.state.app.render;
        }, 300);
        return
      }
      // location.href = '/community/forum.php?mod=mail'
      location.href = "/#/forum/mail";
    },
    getData() {
      this.loading = true;
      getAllCount().then((res) => {
        this.loading = false;
        if (res?.code == 200) {
          const data = res.data || {};
          const count = data.forumNotifyCount + data.systemNotifyCount
          this.$store.dispatch('user/setUnreadNotifyCount',count)
          const list = res.data.messageBox || [];
          this.list = list;
        }
      });
    },
  },
};
</script>

<style scoped>
.reply-msg {
  border-bottom: 1px solid #eaedf0;
  cursor: pointer;
  padding: 20px 0;
}
.reply-msg:first-of-type{
  padding-top: 0;
}

.reply-msg-inner {
  display: flex;
  width: 100%;
  position: relative;
}

.reply-msg-avatar {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
  margin-right: 16px;
  margin-top: 2px;
}
.reply-msg-content {
  width: 230px;
}

.reply-msg-content div:nth-child(3) {
  font-size: 12px;
  color: #a5abb0;
}

.msg-content {
  padding: 9px 18px 51px 18px;
  width: 396px;
  position: relative;
}

.link-btn {
  position: absolute;
  color: var(--1-1D1D1D, #1D1D1D);
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  width: 100%;
  text-align: center;
  left: 0;
  bottom: 8px;
}

.link-btn span {
  cursor: pointer;
}

.reply-msg-content > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.loading-box,
.no-data-box {
  height: 234px;
  color: #b1b1b4;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.count {
  position: absolute;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  background-color: #ed594a;
  height: 20px;
  min-width: 20px;
  /* padding: 0 5px; */
  border-radius: 10px;
  line-height: 19px;
  text-align: center;
  transform: scale(0.8);
  top: -10px;
  left: 8px;
}
</style>
